// extracted by mini-css-extract-plugin
export default {"nav":"navItems_nav__KcDgy","li":"navItems_li__4KJ9a"};